<footer class="w-100 text-sm text-white position-relative">
  <div
    class="container d-sm-flex flex-row justify-content-between align-items-center py-4 text-sm-start">
    <div>
      <a
        href="https://www.swbc.com/privacy-policy"
        target="_blank"
        class="text-white font-bold">
        Privacy Statement
      </a>
      <div>Copyright &copy;{{ currentYear | date: 'yyyy' }}</div>
    </div>
    <div
      class="text-center d-flex flex-row align-items-end justify-content-center justify-content-md-end mt-4 mt-sm-0">
      <em class="mr-3">Powered by</em>
      <img
        src="../assets/svg/Swbc-logo.svg"
        alt="SWBC Logo"
        style="width: 75px" />
    </div>
  </div>
</footer>
